import React from 'react';
import RegistrationForm from '../components/specific/RegistrationForm';

function Registration() {
  return (
    <div className="min-h-screen bg-[#F5F5DC] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-300">
          {/* Header */}
          <div className="bg-[#556B2F] text-white p-6 text-center">
            <h1 className="text-2xl font-bold mb-2">Create Your Account</h1>
            <p className="text-base opacity-90">Join your family's story collection</p>
          </div>
          
          {/* Content */}
          <div className="p-8">
            <RegistrationForm />
            <p className="text-center mt-4 text-sm text-gray-600">
              Already have an account? <a href="/login" className="text-[#556B2F] hover:underline">Log in here</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registration;